export default __webpack_public_path__ + "static/media/about-page-img.78613f37.png";